import axios from 'axios';

export async function getData(url: string): Promise<any> {
  try {
    const response = await axios.get(url);
    return response;
  } catch (err) {
    return null;
  }
}
